import React from 'react';
import { t } from '@lingui/macro';

import { Flex, Heading, Paragraph } from '@rover/kibble/core';

import { useRevampCta } from '../../hooks/useRevampCta';

const RevampNotApprovedCta = (): JSX.Element => {
  const { sitterData } = useRevampCta();
  const sitterName = sitterData.shortName;

  return (
    <Flex flexDirection="column">
      <Heading size="400" webProps={{ responsive: false }}>{t`Coming soon`}</Heading>
      <Paragraph size="200">
        {t`This has not been completed and reviewed by Rover's sitter quality team. Once it has been approved, pet parents will be able to contact ${sitterName}`}
      </Paragraph>
    </Flex>
  );
};

export default RevampNotApprovedCta;
